
import { useState, useEffect } from "react";
import { getAuthEventName, isAdmin as checkIsAdmin } from "@/services/authService";

export const useAdminStatus = () => {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        const isAdminUser = await checkIsAdmin();
        setIsAdmin(isAdminUser);
      } catch (error) {
        console.error("Error checking admin status:", error);
      }
    };
    
    checkAdminStatus();
    
    const handleAuthChange = async () => {
      const isAdminUser = await checkIsAdmin();
      setIsAdmin(isAdminUser);
    };

    const authEventName = getAuthEventName();
    window.addEventListener(authEventName, handleAuthChange);
    window.addEventListener("storage", handleAuthChange);
    
    return () => {
      window.removeEventListener(authEventName, handleAuthChange);
      window.removeEventListener("storage", handleAuthChange);
    };
  }, []);

  return { isAdmin };
};
